import {useEffect, useState} from "react";
import {API, Endpoints} from "@brg/api";
import {useProfile} from "@brg/auth";
import {clearBookCard, setBookCard} from "../../../features/QueuePaymenrt/slices/OrderSlice";
import {useDispatch} from "react-redux";
import useAuthStateReady from "shared/hooks/useAuthStateReady";

export const useGetBookCopyCard = (bookId?: string, time?: any) => {
    const [resp, setResp] = useState<any>(null);
    const [error, setError] = useState(false);
    const profile = useProfile();
    const [isLoading, setIsLoading] = useState(!!profile?.accountId && !!bookId);
    const dispatch = useDispatch()
    const authStateReady = useAuthStateReady()

    useEffect(() => {
        if (!profile?.accountId || !bookId || !authStateReady) return;

        setIsLoading(true)
        API.request()
            .endpoint(Endpoints.cardsMnePw)
            .url('/api/Card/GetList')
            .get()
            .addQuery('thematicIds', ['my_purchases', 'book_museum'])
            .addQuery('status', 2)
            .addQuery('isHeaderIgnored', 'true')
            .addQuery('userIds',  [profile?.accountId])
            .addQuery('relatedEntityIds',  [bookId])
            .send()
            .then((r) => r.json())
            .then((r) => {
                if (r?.data?.length > 0 ) setResp(r?.data[0])
                setIsLoading(false)
                if (r?.status === 400 || r?.status === 403) {
                    return;
                }
            })
            .catch((e) => {
                setIsLoading(false)
                setError(true)
            })
    }, [time, authStateReady, profile, bookId])

    useEffect(() => {
        if (!resp) return;
        dispatch(setBookCard({
            bookCard: resp
        }))

        return () => {
            dispatch(clearBookCard())
        }
    }, [resp, time])

    return {copyCard: resp, isLoading, error};
}import {useEffect, useState} from "react";
import {API, Endpoints} from "@brg/api";
import {useProfile} from "@brg/auth";
import {clearBookCard, setBookCard} from "../../../features/QueuePaymenrt/slices/OrderSlice";
import {useDispatch} from "react-redux";
import useAuthStateReady from "shared/hooks/useAuthStateReady";

export const useGetBookCopyCard = (bookId?: string, time?: any) => {
    const [resp, setResp] = useState<any>(null);
    const [error, setError] = useState(false);
    const profile = useProfile();
    const [isLoading, setIsLoading] = useState(!!profile?.accountId && !!bookId);
    const dispatch = useDispatch()
    const authStateReady = useAuthStateReady()

    useEffect(() => {
        if (!profile?.accountId || !bookId || !authStateReady) return;

        setIsLoading(true)
        API.request()
            .endpoint(Endpoints.cardsMnePw)
            .url('/api/Card/GetList')
            .get()
            .addQuery('thematicIds', ['my_purchases', 'book_museum'])
            .addQuery('status', 2)
            .addQuery('isHeaderIgnored', 'true')
            .addQuery('userIds',  [profile?.accountId])
            .addQuery('relatedEntityIds',  [bookId])
            .send()
            .then((r) => r.json())
            .then((r) => {
                if (r?.data?.length > 0 ) setResp(r?.data[0])
                setIsLoading(false)
                if (r?.status === 400 || r?.status === 403) {
                    return;
                }
            })
            .catch((e) => {
                setIsLoading(false)
                setError(true)
            })
    }, [time, authStateReady, profile, bookId])

    useEffect(() => {
        if (!resp) return;
        dispatch(setBookCard({
            bookCard: resp
        }))

        return () => {
            dispatch(clearBookCard())
        }
    }, [resp, time])

    return {copyCard: resp, isLoading, error};
}